export default "__VITE_ASSET__fb596bcd__"